import bankCodes from '@/languages/ko-kr/bank-codes'
import enablingStatus from '@/languages/ko-kr/enabling-status'
import invoiceIssueStatus from '@/languages/ko-kr/invoice-issued-status'
import transferPasswords from '@/languages/ko-kr/transfer-passwords'

export default {
  'bank-codes': {
    ...bankCodes,
  },
  'page': '페이지',
  'keep': 'Keep',
  'keep-kr': '더낸세금',
  'kakao': '카카오',
  'kakaotalk': '@:terms.kakao톡',
  'certificate-number': '인증번호',
  'phone-number': '전화번호',
  'mobile-number': '휴대폰 번호',
  'time': '시간',
  'certificate-time': '인증시간',
  'email': '이메일',
  'sms': '문자메시지',
  'min': '분',
  'sec': '초',
  'year': '년',
  'month': '월',
  'day': '일',
  'days': '일',
  'address': '주소',
  'next': '다음',
  'required': '필수',
  'name': '이름',
  'name-exaltation': '성함',
  'biz-name': '회사명',
  'biz-class': '종목',
  'biz-type': '업태',
  'registration-number': '등록번호',
  'biz': '회사',
  'boss': '대표',
  'biz-no': '사업자등록번호',
  'owner-name': '대표자명',
  'business-operator': '사업자',
  'individual': '개인',
  'corporate': '법인',
  'search': '검색',
  'confirm': '확인',
  'delete': '삭제',
  'certification': '인증',
  'certificate': '공동인증서',
  'register': '등록',
  'giro': '인터넷지로',
  'popbill': '@:terms.hometax',
  'hometax': '홈택스',
  'hometax-kr': '국세청',
  'payment': '납부',
  'count': '건',
  'currency': '원',
  'total': '총',
  'amount': '금액',
  'bank': '은행',
  'account': '계좌',
  'otp': 'OTP',
  'foreign-currency': '외화',
  'withdrawal': '출금',
  'bank-account': '@:terms.withdrawal @:terms.account',
  'bill': '고지서',
  'tax-free-invoice': '계산서',
  'invoice-bill': '계산서',
  'password': '비밀번호',
  'my': '내',
  'user': '사용자',
  'after': '후',
  'due-date': '기한',
  'excess': '초과',
  'time-over': '경과',
  'indefinite': '기한 없음',
  'complete': '완료',
  'failed': '실패',
  'error': '오류',
  'able': '가능',
  'exception': '제외',
  'need': '필요',
  'home': '홈',
  'purchase': '매입',
  'tax': '세금',
  'paytax': '세금 납부',
  'issue': '발행',
  'invoice': '@:terms.tax@:terms.tax-free-invoice',
  'purchase-invoice': '@:terms.purchase @:terms.tax@:terms.tax-free-invoice',
  'issued-invoices-title': '@:terms.invoice @:terms.issue',
  'setting': '설정',
  'notification': '알림',
  'transfer': '송금',
  'transfertance': '송금',
  'client': '거래처',
  'contact': '연락처',
  'alarm': '알림',
  'fee': '수수료',
  'cancel': '취소',
  'info': '정보',
  'transaction': '거래',
  'assessment': '부과',
  'additional-tax': '가산세',
  'order': '정렬',
  'apply': '적용',
  'edit': '수정',
  'reset': '초기화',
  'entire': '전체',
  'change': '변경',
  'status': '상태',
  'enabling': '연동',
  'expired': '만료',
  'detail': '자세히',
  'exemption': '면제',
  'management': '관리',
  'bankbook': '통장',
  'result': '결과',
  'notice': '공지사항',
  'use': '사용',
  'corporation': '기업',
  'lookup': '조회',
  'sign-up': '가입',
  'business': '사업',
  'summary': '적요',
  'add': '추가',
  'admin': '관리자',
  'invite': '초대',
  'home-screen': '홈 화면',
  'start': '시작',
  'wrong': '잘못된',
  'access': '접근',
  'auth': {
    'login': '로그인',
  },
  'sign-out': '로그아웃',
  'input': '입력',
  'bank-account-owner': '예금주',
  'bank-account-number': '계좌번호',
  'system': '시스템',
  'try': '시도',
  'send': '전송',
  'direct': '직접',
  'close': '닫기',
  'manager': '담당자',
  'item': '품목',
  'spec': '규격',
  'remark': '비고',
  'unit-cost': '단가',
  'supply-amount': '공급가액',
  'tax-amount': '세액',
  'total-amount': '합계금액',
  'quantity': '수량',
  'surtax': '부가세',
  'tax-free': '면세',
  'taxation': '과세',
  'tax-zero': '영세',
  'preview': '미리보기',
  'review': '검토',
  'cash': '현금',
  'chk-bill': '수표',
  'note': '어음',
  'confirm-number': '승인번호',
  'write-date': '작성일자',
  'issue-date': '발급일자',
  'send-date': '전송일자',
  'purchase-date': '@:terms.item일자',
  'credit-receivable': '외상 미수금',
  'tax-registration-number': '종사업장번호',
  /* menu */
  'to-issue': '@:terms.issue하기',
  'to-lookup-transfer': '@:terms.lookup 및 @:terms.transfer하기',

  'copy': '복사',
  'maximum': '최대',
  'minimum': '최소',
  'download': '다운로드',
  'purpose-type': '청구/영수',
  'inquiry': '문의',

  'ei': '고용산재보험 토털',
  'employee': '직원',
  'company-location': '소재지',
  'company-kind': '업종',
  'prediction': '예상',
  'recommend': '추천',
  'outline': '개요',
  'particular': '상세',
  'content': '내용',
  'birthday': '생년월일',
  'persons': '명',
  'hidden': '숨은',
  'subsidy': '지원금',
  'free': '무료',
  'consultation': '상담하기',
  'heum': '혜움',
  'labs': '랩스',
  'hidden-subsidy': '@:terms.hidden @:terms.subsidy',
  'youth': '청년',
  'employ': '고용',
  'proposal': '신청',
  'months': '개월',

  'taxrefund': '세금 환급',

  /* cert-center*/
  'cert-center': {
    'title': '@:terms.enabling @:terms.management',
    'certificate': '공동인증서',
    'cert': '인증서',
    'register': '등록',
    'bank': '은행',
    'enabling': '연동',
    'cancel': '취소',
    'expiry-date': '만료일자',
    'corporate': '법인사업자 | 개인사업자',
    'will-expired': '오늘 만료됩니다. | 내일 만료됩니다. | {days}일 후 만료됩니다.',
    'select-bank-codes': ['연결할', '은행을 선택해주세요'],
    'ei': '고용산재보험 토털',
    'institution': {
      'giro': '@:terms.giro',
      'hometax': '@:terms.hometax',
      'popbill': '@:terms.hometax',
      'ei': '@:terms.ei',
      'bank': '@:terms.bank',
      'type': {
        'giro': '세금 조회/납부',
        // 'hometax': '세금계산서 조회',
        'hometax': '세금 조회',
        'popbill': '세금계산서 발행',
        'hometax-popbill': '세금계산서 조회, 발행',
        'bank': '송금',
        'ei': '지원금 조회',
      },
      ...bankCodes,
    },
    'status': {
      ...enablingStatus,
    },
    'failed-reason': '연동 실패사유',
  },

  /* password */
  'passwords': {
    'password': '비밀번호',
    'bank-account': '계좌',
    'confirm': '확인',
    'cancel': '취소',
    'user': '이용자',
    'max': '영문 숫자 8자리',
    'close': '닫기',
    ...bankCodes,
    'transfer-passwords': {...transferPasswords},
  },

  /* bank */
  'banks': {
    'title': '@:terms.withdrawal @:terms.account @:terms.management',
    'bank': '@:terms.bank',
    'account': '계좌',
    'bank-account': '출금 계좌',
    'certificate': '공동인증서',
    'enabling': '연결',
    'number': '계좌번호',
    'withdrawal' : '@:terms.withdrawal @:terms.bank',
    'owner': '예금주',
    'search': '찾기',
    'register': '등록',
    'currency': '@:terms.currency',
    'payment': '@:terms.payment',
    'delete': '@:terms.delete',
    'bank-codes': {...bankCodes},
    'transfer': '@:terms.transfer',
    'foreign-currency': '@:terms.foreign-currency'
  },

  /* certificates */
  'certificates': {
    'certificate': '공동인증서',
    'register': '등록',
    'code': '인증코드',
    'close': '닫기',
    'giro': '인터넷지로',
    'hometax': '홈택스',
    'popbill': '홈택스',
    'ei': '고용산재보험 토털',
    'bank': '은행',
    'bank-codes': {...bankCodes},
  },

  'invoice-issued-status': {
    ...invoiceIssueStatus,
  },

}
